module.exports = __webpack_public_path__ + "img/applicationPassed.c1158823.png";